import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { CurrencyInfo } from './currency-info.model';
import { HomeOverviewMetric } from './home-overview-metric.model';
import { MonthSales } from './month-sales.model';

export enum OverviewMetricEnum {
  unpaid = 'unpaid',
  unsent = 'unsent',
  overdue = 'overdue',
  monthly_sales = 'monthly_sales',
  pending_estimates = 'pending_estimates',
}

export const HOME_METRICS_SCHEMA = Object.freeze({
  CURRENCY_INFO: CurrencyInfo,
  UNPAID: HomeOverviewMetric,
  UNSENT: HomeOverviewMetric,
  OVERDUE: HomeOverviewMetric,
  PENDING_ESTIMATES: HomeOverviewMetric,
  MONTH_SALES: MonthSales,
});
const RECORD = generateSchema(HOME_METRICS_SCHEMA);
const KEYS: any = generateKeys(HOME_METRICS_SCHEMA);

export class HomeMetrics extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.CURRENCY_INFO,
        value: new CurrencyInfo(this.currencyInfo),
      },
      {
        key: KEYS.UNPAID,
        value: new HomeOverviewMetric(this.unpaid),
      },
      {
        key: KEYS.UNSENT,
        value: new HomeOverviewMetric(this.unsent),
      },
      {
        key: KEYS.OVERDUE,
        value: new HomeOverviewMetric(this.overdue),
      },
      {
        key: KEYS.PENDING_ESTIMATES,
        value: new HomeOverviewMetric(this.pendingEstimates),
      },
      {
        key: KEYS.MONTH_SALES,
        value: new MonthSales(this.monthSales),
      },
    ]);

    return selfModel as HomeMetrics;
  }

  get currencyInfo(): CurrencyInfo {
    return this.get(KEYS.CURRENCY_INFO);
  }

  get unpaid(): HomeOverviewMetric {
    return this.get(KEYS.UNPAID);
  }

  get unpaidType(): string {
    return OverviewMetricEnum.unpaid;
  }

  get unpaidDocCount(): number {
    return this.unpaid.docCount;
  }

  get unpaidTotal(): number {
    return this.unpaid.total;
  }

  get unsent(): HomeOverviewMetric {
    return this.get(KEYS.UNSENT);
  }

  get unsentType(): string {
    return OverviewMetricEnum.unsent;
  }

  get unsentDocCount(): number {
    return this.unsent.docCount;
  }

  get unsentTotal(): number {
    return this.unsent.total;
  }

  get overdue(): HomeOverviewMetric {
    return this.get(KEYS.OVERDUE);
  }

  get overdueType(): string {
    return OverviewMetricEnum.overdue;
  }

  get overdueDocCount(): number {
    return this.overdue.docCount;
  }

  get overdueTotal(): number {
    return this.overdue.total;
  }

  get pendingEstimates(): HomeOverviewMetric {
    return this.get(KEYS.PENDING_ESTIMATES);
  }

  get monthSales(): MonthSales {
    return this.get(KEYS.MONTH_SALES);
  }

  get monthSalesType(): OverviewMetricEnum {
    return OverviewMetricEnum.monthly_sales;
  }

  get pendingEstimatesType(): OverviewMetricEnum {
    return OverviewMetricEnum.pending_estimates;
  }
}
